import { Line, Group } from 'react-konva';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import {
  COLUMN_WIDTH,
  COLUMN_HEIGHT,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';
import {
  DATE_COLUMN_WIDTH,
  HEADER_ROW_HEIGHT,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { IGridLayer } from './grid-layer.interface';

const GridLayer = ({ fullWidth, fullHeight, ganttData, dateValues }: IGridLayer) => {
  const { light } = PLATFORM_THEME_COLORS.grayVariations;

  return (
    <Group listening={false}>
      {/* Body right border */}
      <Line
        stroke={light}
        strokeWidth={1}
        points={[fullWidth, HEADER_ROW_HEIGHT, fullWidth, fullHeight]}
      />

      {/* Row bottom border */}
      {dateValues.map(({ dateInFormat }, index) => {
        const endTopColumnPosition = index * COLUMN_HEIGHT + HEADER_ROW_HEIGHT;
        const endBottomColumnPosition = endTopColumnPosition + COLUMN_HEIGHT;

        return (
          <Line
            key={dateInFormat}
            stroke={light}
            strokeWidth={2}
            points={[
              DATE_COLUMN_WIDTH,
              endBottomColumnPosition,
              fullWidth,
              endBottomColumnPosition,
            ]}
          />
        );
      })}

      {/* Column right border */}
      {ganttData.map(({ employee }, index) => {
        const columnStart = index * COLUMN_WIDTH + DATE_COLUMN_WIDTH + COLUMN_WIDTH;

        return (
          <Line
            key={employee._id}
            strokeWidth={1}
            stroke={light}
            points={[columnStart, HEADER_ROW_HEIGHT, columnStart, fullHeight]}
          />
        );
      })}
    </Group>
  );
};

export default GridLayer;
